import { Notification } from "element-ui";

export const ERROR_MESSAGES = {
  500: "Server error - please try again later",
  404: "Resource not found",
  429: "Too many requests - please slow down",
  NETWORK_ERROR: "Network error - check your connection",
  DEFAULT: "Something went wrong",
};

export function showApiErrorNotification(error) {
  const status = error?.response?.status;
  let message;

  if (!status) {
    // Network error - no response from server
    message = ERROR_MESSAGES.NETWORK_ERROR;
  } else if (ERROR_MESSAGES[status]) {
    message = ERROR_MESSAGES[status];
  } else {
    message = ERROR_MESSAGES.DEFAULT;
  }

  Notification({
    title: "Error",
    message,
    type: "error",
    position: "bottom-right",
    duration: 5000,
  });
}
